var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogBase',{attrs:{"dialog":_vm.dialog,"color":"primary","persistent":"","dark":""}},[_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.message)+"\n        "),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"white"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }